import Icon from 'Components/Header/Components/LanguageSelector/Components/Icon/Icon';

export default Icon;
